import { gridConnectionDetailsRoute } from '@/modules/charge-center/grid-connections/grid-connection-details/route';
import { createRoute, redirect } from '@tanstack/react-router';

export const gridConnectionDetailsIndexRoute = createRoute({
  getParentRoute: () => gridConnectionDetailsRoute,
  path: '/',
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/charge-center/grid-connections/$gridConnectionId/charge-points',
      params: { gridConnectionId: params.gridConnectionId },
    });
  },
});
